/**
 * 微信公众号绑定账号页面
 * 2020-10-23 wuw
 */
import React from 'react';
import { Radio } from 'antd';
import { Button, Toast, InputItem, NavBar, TextareaItem, Result, Icon,Tabs} from 'antd-mobile';
import http from '../../../axios/wechatHttp'
import {getUrlParam} from '../../../util/util.js';
import '../financial/FinancialDetail.css'
import 'antd-mobile/dist/antd-mobile.css';
import { createForm } from 'rc-form';
import '../contract/ContractIndex.css'

class FinancialDetailForm extends React.Component {
    state = {
        detail: {},
        value: '',
        auditMind: '',   // 审核意见
        status: '',
        successFlag: false,
        show: false,
        tabs:[{title:'合同信息'},{title:'审核记录'}],
        isShowFlag:false,
    }
    componentDidMount() {
        let id = getUrlParam("id");
        this.getfinancialDetail(id)
      
    }

    onChange = e => {
        this.setState({
            value: e.target.value,
        });
    }
    getfinancialDetail = (id) => {
        let status = getUrlParam("status");
        http.get({
            url: "/market/contract/query/contractAndBills/"+id,
            // data: { id: '310' },
            success: (res) => {
                if(res.status==='COMMIT'||res.status==="MERCHANTS_AUDITED"||res.status==='FINANCE_AUDITED'){
                    if (res.status === status) {
                        this.setState({
                            isShowFlag: true
                        })
                        
                    }
                }
                this.setState({
                    detail: res,
                    show: true,
                    auditMind: res.auditMind,

                })
            }
        })
    }
    confirmExamine = () => {
        let url = '';
        let status = getUrlParam("status");
        let value = this.state.value;
        let auditMind = this.state.auditMind;
        if (value !== '') {
            if (value === 1) {
                if(status==='COMMIT'){
                    url="/market/contract/merchants/audited";
                }else if(status==='MERCHANTS_AUDITED'){
                    url="/market/contract/finance/audited";
                }else if(status==='FINANCE_AUDITED'){
                    url="/market/contract/audited";
                }
            } else if (value === 2) {
                if(status==='COMMIT'){
                    url="/market/contract/merchants/reject"
                }else if(status==='MERCHANTS_AUDITED'){
                    url="/market/contract/finance/reject";
                }else if(status==='FINANCE_AUDITED'){
                    url="/market/contract/reject";
                }
            }
            http.post({
                url: url,
                data: {
                    id: this.state.detail.id,
                    auditMind: auditMind
                },
                success: (res) => {
                    this.setState({
                        successFlag: true
                    })
                },
            })
        } else {
            if (value === '') {
                Toast.fail('请选择审核！', 1);
            }
            return
        }
    }
    textAreaInput = (val) => {
        this.setState({
            auditMind: val
        });
    }

    show = () => {
        const {detail, show,tabs} = this.state;
        if (show) {
            return (<div>
            <NavBar mode="dark">合同审核</NavBar>
            <div className="contract-statusStr">当前状态：{detail.statusStr?detail.statusStr:''}</div>
            <Tabs tabs={tabs}
                initialPage={0}
                >
                <div className="contract-tabs">
                    {!this.state.successFlag ? <div>
                        <InputItem value={detail.clientName ? detail.clientName : '无'} editable={false}>租户名称</InputItem>
                        <InputItem value={detail.berthIds ? detail.berthIds : '无'} editable={false}>租赁铺位</InputItem>
                        <InputItem value={detail.rentStartDate ? detail.rentStartDate + ' 至 ' + detail.rentEndDate: '无'} editable={false}>租赁周期</InputItem>
                        <InputItem value={detail.rentArea? detail.rentArea+'㎡': '无'} editable={false}>租赁面积</InputItem>
                        {detail.rentStandardList?detail.rentStandardList.map((item,index)=>{
                            return <div class="am-list-item  am-list-item-middle">
                            <div class="am-list-line">
                                <div class="am-input-label am-input-label-5">租金单价</div>
                                <div class="am-input-control">
                                    <input placeholder="" type="text" readonly="" value={item.rentStartDate?item.rentStartDate+"：" +item.rentPerUnit+"元" : '无'} />
                                </div>
                            </div>
                        </div>
                        }):''}
                        {detail.busiFeeStandardList?detail.busiFeeStandardList.map((item,index)=>{
                            return <div class="am-list-item  am-list-item-middle">
                            <div class="am-list-line">
                                <div class="am-input-label am-input-label-5">管理费单价</div>
                                <div class="am-input-control">
                                    <input placeholder="" type="text" readonly="" value={item.rentStartDate?item.rentStartDate+"：" +item.rentPerUnit+"元" : '无'} />
                                </div>
                            </div>
                        </div>
                        }):''}
                        
                        
                        <InputItem value={detail.leaseDepositFee ? detail.leaseDepositFee : '无'} editable={false}>押金金额</InputItem>
                        {this.state.isShowFlag?<div>
                            <div className="am-list-item am-input-item am-list-item-middle">
                            <div className="am-list-line">
                                <div className="am-input-label am-input-label-5">审核</div>
                                <div className="am-input-control">
                                    <Radio.Group onChange={this.onChange} value={this.state.value}>
                                        <Radio value={1}>同意</Radio>
                                        <Radio value={2}>不同意</Radio>
                                    </Radio.Group> 
                                </div>  
                            </div>
                        </div>
                        <TextareaItem
                            title="审核意见"
                            value={this.state.auditMind}
                            // editable={detail.status === 0}
                            placeholder="选填"
                            autoHeight
                            onChange={this.textAreaInput}
                        />
                        <div className="auditBtnbox">
                            <Button type="primary"   onClick={this.confirmExamine} className="auditBtn">提交</Button>
                        </div>
                        </div>:''}
                        
                        </div>
                        : <div className="successPage"><Result img={<Icon type="check-circle" className="spe" style={{ fill: '#1F90E6' }} />} title="审核通过" /></div>}
                </div>
                <div className="contract-tabs">
                    <div className="contractRecord-header">
                        <div style={{width:'35%'}} className="contractRecord-item">操作时间</div>
                        <div style={{width:'15%'}} className="contractRecord-item">操作人</div>
                        <div style={{width:'25%'}} className="contractRecord-item">类型</div>
                        <div style={{width:'25%'}} className="contractRecord-item">备注</div>
                    </div>
                    {detail.contractLogList?detail.contractLogList.map((item,index)=>{
                        return<div className="contractRecord-content" key={index}>
                            <div className="contractRecord-item" style={{width:'35%'}}>{item.insertTime?item.insertTime:''}</div>
                            <div className="contractRecord-item" style={{width:'15%'}}>{item.operator?item.operator:''}</div>
                            <div className="contractRecord-item" style={{width:'25%'}}>{item.type?item.type:''}</div>
                            <div className="contractRecord-item" style={{width:'25%'}}>{item.remark?item.remark:''}</div>
                        </div>
                    })
                    :<div className="contract-noContent"></div>}
                </div>
            </Tabs>
        
        </div>);
        }
        else {
            return "";
        }
    }
    render() {
        
        return <div className="examinebox">
            {this.show()}
        </div>
    };
}
const FinancialDetail = createForm()(FinancialDetailForm);
export default FinancialDetail;